import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateCheckboxInputFormField(
  params: FormFieldGenerationParams<'checkboxInput'>,
): PartialPropsOf<'checkboxInput'> {
  let props: PartialPropsOf<'checkboxInput'> = applyPropsPatch(params.props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, { content: { input: { readonly: true } } });
  }

  return props;
}
